var _rect, _path, _path2, _path3, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIotSafetyEngine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 520,
    fill: "#102a2a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400 100 600 165v105c0 100-82 158-200 190-118-32-200-90-200-190V165z",
    fill: "#14532d",
    stroke: "#86efac",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M400 182v92M354 228h92",
    stroke: "#bbf7d0",
    strokeWidth: 18,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155 390h90M555 390h90M400 440v-38",
    stroke: "#2dd4bf",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 75,
    fill: "#dcfce7",
    fontFamily: "sans-serif",
    fontSize: 35,
    fontWeight: 700
  }, "IOT SAFETY ENGINE")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 485,
    fill: "#86efac",
    fontFamily: "monospace",
    fontSize: 22
  }, "ESP32 SENSOR MONITORING")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIotSafetyEngine);
export default __webpack_public_path__ + "static/media/iot-safety-engine.de4ab8eee5feaf1134fd4a48bb99bc0e.svg";
export { ForwardRef as ReactComponent };